export default {
  //
  frogs: "青萍商用多功能檢測儀",
  frogS: "青萍商用多功能檢測儀",
  frogs_step1_h1: "青萍商用多功能檢測儀",
  frogs_step1_device_description_1: "高精度傳感器",
  frogs_step1_device_description_2: "多種外接探頭可選",
  frogs_step1_device_description_3: "遠程無線監控",
  frogs_step1_device_description_4: "超限即時通知",

  frogs_step1_table_1_1: " ",
  frogs_step1_table_1_2: "溫度",
  frogs_step1_table_1_3: "濕度",

  frogs_step1_table_2_1: "量程",
  frogs_step1_table_2_2: "-30 ~ 60°C",
  frogs_step1_table_2_3: "0 ~ 100%RH",

  frogs_step1_table_3_1: "典型準確度",
  frogs_step1_table_3_2: "±0.5°C {br}(0 ~ 50°C)",
  frogs_step1_table_3_3: "±5%RH {br}(10 ~ 90%RH)",

  frogs_step1_table_4_1: "分辨力",
  frogs_step1_table_4_2: "0.1°C",
  frogs_step1_table_4_3: "1%RH ",

  frogs_step1_look_specification: "查看完整規格",

  // 222
  frogs_step2_h1: "提供精準檢測與可靠連接",

  frogs_step2_1_1: "內建高精度溫濕度傳感器",
  frogs_step2_1_2: "內建瑞士 Sensation 溫濕度傳感器，精度高，反應靈敏。",

  frogs_step2_2_1: "支持外接探頭",
  frogs_step2_2_2: "採用航空插頭連接方式，穩固可靠。",

  //333
  frogs_step3_h1_1: "整機 IP56{sup} 級防護",
  // frogs_step3_h1_2: " ",

  //444
  frogs_step4_h1: "多種外接探頭可選",
  frogs_step4_h2: "查看規格",
  frogs_step4_l_title: "溫度探頭",
  frogs_step4_r_title: "高濃度二氧化碳探頭（扁線）",

  // 6666
  frogs_step6_h1: "兩種供電方式",

  frogs_step6_1_1: "方式一：5號電池供電",
  frogs_step6_1_2: "支持鋰鐵電池、鹼性電池。不支持碳性電池、鎳氫電池。",

  frogs_step6_2_1: "方式二：USB-C 接口供電",
  frogs_step6_2_2: "可長期連接 USB-C 電源。不支持充電。",

  // 8888
  frogs_step8_h1: "長距離無線通信方案，三選一",
  frogs_step8_info_1: "使用環境需要有穩定 Wi-Fi 信號。",
  frogs_step8_info_2: "需配備 LoRaWAN 網關或基站。",
  frogs_step8_info_3: "需當地中國移動提供相關網絡服務",
  frogs_step8_info_3_2: "。",

  //999
  frogs_step9_h1_1: "外置天線，信號更佳",
  frogs_step9_h1_2: "採用 SMA 接口，可輕鬆安裝和維護。",

  //10 10
  frogs_step10_h1_1: "青萍物聯",
  frogs_step10_h1_2:
    "為青萍商用智能硬體產品提供設備和數據管理、實時警報服務的物聯網平台。",

  //11 11 11
  frogs_step11_h1_1: "意外斷網，數據不丟失",
  frogs_step11_h1_2: "設備自身可存儲 2,880 組",
  frogs_step11_h1_3:
    "數據，意外斷網也無需擔心數據丟失，網絡恢復後可自動同步數據到雲端。",

  //13 13 13 13
  frogs_step13_h1_1: "兩種安裝方式",
  frogs_step13_h1_2: "DIN 導軌固定",
  frogs_step13_h1_3: "磁吸",

  frogs_bottom_1:
    "經實驗室測試，在 IEC60529 標準下，青萍商用多功能檢測儀的防護效果達到 IP56 級別（使用噴頭內徑為 6.3 毫米的噴嘴，從 2.5~3 米距以 12.5 升/分鐘的供水強度持續噴灑 3 分鐘）。本品不可浸泡於水中或長期處在揚塵環境中，防水、防塵功能並非永久有效，防護性能可能會因日常使用而下降。",
  frogs_bottom_2: "外接探頭需單獨購買。",
  frogs_bottom_3:
    "設備出廠內寘 SIM 卡，含 6 年中國移動 NB-IoT 流量資費（限 50MB/年）。不同批次所包含的資費可能不同。",
  frogs_bottom_4: "按 15 分鐘記錄一組數據計算，設備可在本地存儲 30 天的數據。",
  frogs_bottom_5:
    "本品可被安裝在 35 毫米 DIN 導軌上，DIN 導軌及固定夾需另行購買。",

  // pop-up co2
  frogs_pop_co2_h1: "高濃度二氧化碳探頭（扁線）",
  frogs_pop_co2_h2: "採用多重結構設計，具有良好的防護性和耐用性。",
  frogs_pop_co2_tab_1_1: "不鏽鋼內襯",
  frogs_pop_co2_tab_1_2: "採用網狀設計，保持良好通風的同時，可防止異物進入。",
  frogs_pop_co2_tab_2_1: "高精度傳感器",
  frogs_pop_co2_tab_2_2:
    "內置瑞士 Sensirion 二氧化碳傳感器，體積小巧，性能出色，穩定性高。",
  frogs_pop_co2_tab_3_1: "鋁合金和矽膠外殼",
  frogs_pop_co2_tab_3_2:
    "具有良好的抗氧化性，適用於高溫、低溫和高濕度等環境。鋁合金優異的導熱性可加速熱量傳導，提高傳感器響應速度。",
  frogs_pop_co2_item_1: "二氧化碳量程",
  frogs_pop_co2_item_2: "典型準確度",
  frogs_pop_co2_item_3: "工作環境溫度",
  frogs_pop_co2_item_4: "工作環境濕度",
  frogs_pop_co2_item_1_2: "0 ~ 25%",
  frogs_pop_co2_item_2_2: "±(1 vol% + 3% m.v.)",
  frogs_pop_co2_item_3_2: "-20 ~ 85°C",
  frogs_pop_co2_item_4_2: "0 ~ 95%RH（無凝露環境）",

  // pop-up temp
  frogs_pop_temp_h1: "溫度探頭",
  frogs_pop_temp_h2: "可持續放入水中，或無線信號被隔絕的空間，例如冰箱。",
  frogs_pop_temp_item_1: "溫度量程",
  frogs_pop_temp_item_2: "典型準確度",
  frogs_pop_temp_item_3: "分辨率",
  frogs_pop_temp_item_4: "材質",
  frogs_pop_temp_item_5: "防護等級",
  frogs_pop_temp_item_1_2: "-40 ~ 125°C",
  frogs_pop_temp_item_2_2: "±0.5°C (0 ~ 50°C)",
  frogs_pop_temp_item_3_2: "0.1°C",
  frogs_pop_temp_item_4_2: "不鏽鋼探頭，矽膠線身。",
  frogs_pop_temp_item_5_2: "IP68*級防護：可防塵，能持續浸水使用。",
  frogs_pop_temp_footer_text:
    "青萍溫度探頭可防塵，能持續浸水使用。經實驗室測試，在 GB/T 4208-2017 標準下，其防護水准達到 IP68 級別（將產品持續浸泡於 1 米深的水中，1 小時後產品外觀和功能依然正常）。該產品的防水、防塵功能並非永久有效，防護效能可能因日常使用而下降。",

  // frogs規格-temp
  frogs_spec_long: "80 毫米",
  frogs_spec_short: "33 毫米",
  frogs_spec_height: "208 毫米",
  frogs_size: "產品尺寸",
  frogs_color: "產品顏色",
  frogs_spec_size: "208 × 80 × 33 毫米（含天線）",
  frogs_temp: "溫度量程",
  frogs_hum: "濕度量程",
  frogs_temperature_pc:
  "-30 ~ 60°C （使用鋰鐵 5 號電池或 USB 供電）{br}-10 ~ 50°C （使用鹼性 5 號電池）",
  frogs_temperature:
    "-30 ~ 60°C （使用鋰鐵 5 號電池或 USB 供電）{br}{br}-10 ~ 50°C （使用鹼性 5 號電池）",
  frogs_humidity: "0 ~ 100%RH",

  frogs_weight: "128 克",
  frogs_screen_size: "64 × 44 毫米",
  frogs_wifi: "Wi-Fi 2.4GHz 或 NB-IoT 或 LoRa",
  frogs_ble: "5.0",
  frogs_battery_support: "電池供電",
  frogs_battery_support_v: "2 節 5 號鋰鐵電池或鹼性電池",
  frogs_USB_support: "USB 供電",
  frogs_package_USB: "5V⎓1A，USB-C",
  frogs_protect: "IP56",
  frogs_package_name: "青萍商用多功能{br}檢測儀",
  frogs_package_battery: "2 節 5 號{br}鋰鐵電池",

  under_ninty2: "請勿長時間在濕度超過 90%RH 的環境下使用。",
  under_ninty3:
    "當已連接 USB 時，設備將只使用 USB 電源工作（不使用電池），設備的 USB 口不支持為電池充電。",

  frogs_device_modal: "產品型號",
  frogs_device_modal_v: "CGF2P-T40",
  frogs_needle_size:
    "傳感器探頭：直徑 6 毫米，長度 50 毫米{br}線身：直徑 5 毫米，長度 1500 毫米{br}連接器：長度 35 毫米",
    frogs_needle_size_m:
    "傳感器探頭：直徑 6 毫米，長度 50 毫米{br}{br}線身：直徑 5 毫米，長度 1500 毫米{br}{br}連接器：長度 35 毫米",
  frogs_first_level: "防護等級{br}",
  frogs_needle_weight: "57 克",
  frogs_needle_connect: "M8 六孔航空插頭",
  frogs_needle_protect: "IP68",

  frogs_needle_material: "不鏽鋼",
  frogs_needle_body: "硅膠",
  frogs_needle_line: "連接器",
  frogs_needle_with: "PET",
  frogs_needle_package_with: "膠帶{br}(用於固定產品)",

  frogs_needle_co2_size:
    "傳感器探頭：直徑 21 毫米，長度 51 毫米 {br}線身：1.5 × 4 毫米，長度 1500 毫米 {br}連接器：長度 35 毫米",
    frogs_needle_co2_size_m:
    "傳感器探頭：直徑 21 毫米，長度 51 毫米 {br}{br}線身：1.5 × 4 毫米，長度 1500 毫米 {br}{br}連接器：長度 35 毫米",

  frogs_needle_co2_tab: "高濃度二氧化碳探頭（扁線）",
  p_co2: "二氧化碳{br}量程",
  needle_co2_temperature: "0 ~ 25%",
  frogs_needle_co2: "青萍高濃度二氧化碳探頭（扁線）",
  frogs_probe_co2_modal_v: "CGF2P-HC-F",
  frogs_needle_co2_weight: "14 克",
  frogs_needle_co2_connect: "M8 六孔航空插頭",
  frogs_first_level_co2: "線身和連接器重量",
  frogs_needle_co2_protect: "21 克",

  frogs_needle_co2_material: "鋁合金、硅膠、不鏽鋼",
  frogs_needle_co2_body: "硅膠",
  frogs_needle_co2_line: "連接器",
  frogs_needle_co2_line_v: "不鏽鋼",
  frogs_needle_co2_with: "PET",
  frogs_needle_co2_package_with: "膠帶{br}(用於固定產品)",

  workEnvironment: "工作環境",
  work_co2_tem: "溫度",
  work_co2_hum: "濕度",
  work_co2_tem_v: " -20 ~ 85°C",
  work_co2_hum_v: "0 ~ 95%RH（無凝露環境）",

  x_co2_bottom: "1500 毫米",
  x_co2_left: "35 毫米",
  x_co2_right: "51 毫米",
  x_co2_right_2: "40 毫米",

  x_bottom: "1500 毫米",
  x_left: "35 毫米",
  x_right: "50 毫米",

  //
  p_probe_type: "外接探頭",
  p_probe_tem: "溫度探頭",
  "p_probe_tem&hum": "濕度探頭",
  "p_probe_c02&tem&hum": "外接 CO2 + 溫濕度",
  p_probe_co2: "CO2 探頭",
  p_probe_none: "無",

  // fix
  frogs_needles: "溫度探頭",
  frogs_needle: "青萍溫度探頭",

  frogs_p_weight: "探头重量",
  frogs_sensor_body: "傳感器線身",

  mp_multi_scene: "多場景專業應用",
  
  frogs_support_1: "溫濕度監測",
  frogs_support_2: "多種外接探頭可選",
};
